import React, { useState, useEffect, useCallback } from 'react';
import { PROMOTION_API_BASE } from '../promotionApi';
import '../styles/EasterPromoPopup.css';

const STORAGE_KEY = 'brainEventPromo2026_discount_v2';

/**
 * Popup promo: reducere la bilete + captură email (codul / detaliile pe email).
 */
function EasterPromoPopup({ delayMs = 2200 }) {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [hp, setHp] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY)) return undefined;
    } catch {
      /* ignore */
    }
    const t = setTimeout(() => setVisible(true), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);

  const dismiss = useCallback(() => {
    setVisible(false);
    try {
      localStorage.setItem(STORAGE_KEY, 'dismissed');
    } catch {
      /* ignore */
    }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    if (hp) {
      setVisible(false);
      return;
    }
    const trimmed = email.trim();
    if (!trimmed) {
      setError('Introdu adresa de email.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${PROMOTION_API_BASE}/api/promotions/leads`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email: trimmed,
          company_website: hp,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.message || data.error || 'Nu am putut salva. Încearcă din nou.');
        setLoading(false);
        return;
      }
      setMessage(
        data.message ||
          'Verifică inboxul (și Spam) pentru codul de reducere și detaliile ofertei.'
      );
      try {
        localStorage.setItem(STORAGE_KEY, 'submitted');
      } catch {
        /* ignore */
      }
    } catch {
      setError('Eroare de rețea. Verifică conexiunea sau încearcă mai târziu.');
    } finally {
      setLoading(false);
    }
  };

  if (!visible) return null;

  return (
    <div
      className="easter-promo-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="easter-promo-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) dismiss();
      }}
    >
      <div className="easter-promo-modal" onClick={(ev) => ev.stopPropagation()}>
        <button type="button" className="easter-promo-close" onClick={dismiss} aria-label="Închide">
          ×
        </button>

        <div className="easter-promo-layout">
          <div className="easter-promo-visual">
            <img
              src="/assets/image-pop-up-reducere.png"
              alt="Brain Event 2026 — reducere specială."
              className="easter-promo-visual-img"
              width="560"
              height="640"
              loading="eager"
              decoding="async"
            />
          </div>

          <div className="easter-promo-content">
            <div className="easter-promo-hero">
              <span className="easter-promo-badge">Brain Event 2026</span>
              <h2 id="easter-promo-title" className="easter-promo-title">
                Primești reducerea pe email
              </h2>
              <p className="easter-promo-sub">
                Lasă adresa ta și îți trimitem codul pentru 5% reducere, plus noutățile despre Brain Event 2026.
              </p>
            </div>

            {message ? (
              <div className="easter-promo-success">
                <p>{message}</p>
                <button type="button" className="easter-promo-btn-primary" onClick={dismiss}>
                  Închide
                </button>
              </div>
            ) : (
              <form className="easter-promo-form" onSubmit={submit} noValidate>
                <label className="easter-promo-label" htmlFor="easter-promo-email">
                  Email
                </label>
                <input
                  id="easter-promo-email"
                  type="email"
                  name="email"
                  autoComplete="email"
                  className="easter-promo-input"
                  placeholder="nume@exemplu.com"
                  value={email}
                  onChange={(ev) => setEmail(ev.target.value)}
                  disabled={loading}
                />
                <div className="easter-promo-hp" aria-hidden="true">
                  <label htmlFor="easter-promo-company">Company website</label>
                  <input
                    id="easter-promo-company"
                    type="text"
                    tabIndex={-1}
                    autoComplete="off"
                    value={hp}
                    onChange={(ev) => setHp(ev.target.value)}
                  />
                </div>
                {error && <p className="easter-promo-error">{error}</p>}
                <button type="submit" className="easter-promo-btn-primary" disabled={loading}>
                  {loading ? 'Se trimite…' : 'Vreau reducerea pe email'}
                </button>
                <button type="button" className="easter-promo-skip" onClick={dismiss} disabled={loading}>
                  Nu acum
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EasterPromoPopup;
